import { moment } from '@/util'

const shortcutsType = {
  'all': {
    text: '全部',
    value: [],
  },
  'today': {
    text: '今日',
    value: ['$d', '+1d'],
  },
  'yesterday': {
    text: '昨日',
    value: ['-1$d', '-1$d+23h+59m+59s'],
  },
  'week': {
    text: '本周',
    value: ['$w', '$w+6d+23h+59m+59s'],
  },
  'lastweek': {
    text: '上周',
    value: ['-1$w', '$w'],
  },
  'month': {
    text: '本月',
    value: ['$M', 'M'],
  },
  'lastmonth': {
    text: '上月',
    value: ['-1$M', '$M'],
  }
}

const checkShortCuts = (v,shortcuts, format) => {
  for(let i = 0 ; i< shortcuts.length ;i++){
    let h = shortcutsType[shortcuts[i]]
    let r = h.value.map(i => moment(i,format))
    if(v[0] == r[0] && v[1] == r[1]){
      return shortcuts[i]
    }
  }
  return 'custom'
}

const isValidDate = (d) => {
  return d && d.length && d[0] && d[1]
}
export default {
  props:{
    'shortcuts':{
      default(){
        return ['all','today','yesterday','week','lastweek','month','lastmonth']
      }
    },
    'type':{
      default:'datetimerange'
    },
    'defaultValue':{
      default:'all'
    },
    'value':null,
    'size':{
      default:'default'
    }
  },
  data(){
    return {
      innervalue:null,
      selectType:null,
      open:false,
      customTimeOptions:{
        disabledDate(date){
          return moment(date.toISOString() + ' > -1$d')
        }
      },
      customTime:[]
    }
  },
  created(){
    this.$watch('defaultValue' , function(nv){
      if( nv ){
        this.selectType = nv
        this.handleChange(nv)
      }
    },{immediate:true})
    
    // this.$watch('value' , function(nv){
    //   if( Array.isArray(nv) && nv.length == 2 ){
    //     let type = checkShortCuts(nv , this.shortcuts , this.format)
    //     this.customTime = nv
    //     this.selectType = type
    //     if( type == 'custom' ){
    //       this.customTime = nv
    //     }else{
    //       this.customTime = []
    //     }
    //   }else{
    //     this.selectType = this.defaultValue
    //     this.customTime = null
    //   }
    // },{immediate:true})
  },
  computed: {
    customTimelabel(){
      const format = 'yyyy-MM-dd'
      if( this.selectType == 'custom' && isValidDate(this.customTime) ){
        return this.customTime.map(i => moment(i, format)).join(' ~ ')
      }else{
        return '自定义'
      }
    },
    format(){
      return this.type == 'daterange' ? 'yyyy-MM-dd' : 'ISO'
    },
    shortcutsData() {
      if (this.shortcuts && this.shortcuts.length) {
        let ret = []
        this.shortcuts.forEach(i => {
          let opts = shortcutsType[i]
          if(opts){
            ret.push({
              text:opts.text , 
              type:i,
              value : () => opts.value.map(i => moment(i, 'yyyy-MM-dd hh:mm:ss')),
              onClick:()=>{
                this.shortcut = opts.text
              }
            })
          }
        })
        return ret
      } else {
        return []
      }
    }
  },
  methods:{
    handleChange(v){
      this.selectType = v
      if(v === 'custom'){
        //this.open = true
      }else{
        this.open = false
        this.customTime = []
        let data = shortcutsType[v]
        let pubData = data.value.map(i => moment(i,this.format))
        this.innervalue = pubData
        this.$emit('input',pubData)
        this.$emit('change',pubData)
      }
    },
    handleOk(v) {
      let pubData = this.customTime.map(i => moment(i , this.format))
      this.open = false
      this.innervalue = pubData
      this.$emit('input',pubData)
      this.$emit('change',pubData)
    },
    openDatePicker(){

      this.open = !this.open
      if( this.open ){
        this.selectType = 'custom'
      }
    }
  },
  render(){
    let shortcuts = this.shortcuts
    let type = this.type || 'datetimerange'
    return <RadioGroup size={this.size} type="button" value={this.selectType} on-on-change={this.handleChange}>
      {
        shortcuts.map(i => {
          let d = shortcutsType[i]
          if(d){
            return <Radio label={i}>{d.text}</Radio>
          }
        })
      }
      <Radio label='custom' style="position:relative;">
        <span on-click={this.openDatePicker} >
        <DatePicker transfer 
            open={this.open}
            v-model={this.customTime}
            confirm
            type={type}
            options={this.customTimeOptions} 
            on-on-ok={this.handleOk}>
            <Icon type="md-calendar" style="margin-right:5px;"/>
            {this.customTimelabel}
        </DatePicker>
        </span>
      </Radio>
    </RadioGroup>
  }
}